import React from 'react';
import { Link } from 'gatsby';
import styled, { css } from 'styled-components';

// Dit doet niks. Dit is de standaard implementatie van een component
export const CtaButton = (props) => (
  <Button {...props}>
    {props.children}
  </Button>
);

// Dit doet niks. Dit is de standaard implementatie van een component
export const CtaLink = (props) => (
  <StyledLink {...props}>
    {props.children}
  </StyledLink>
);

// Dit doet niks. Dit is de standaard implementatie van een component
export const CtaOutboundLink = (props) => (
  <StyledOutboundLink {...props}>
    {props.children}
  </StyledOutboundLink>
);

const getVariant = (variant) => {
  if (variant === 'primary') {
    return css`
      background-color: ${(props) => props.theme.primaryColor};
      border: 1px solid ${(props) => props.theme.primaryColor};
    `;
  }
  if (variant === 'secondary') {
    return css`
      background-color: ${(props) => props.theme.secondaryColor};
      border: 1px solid ${(props) => props.theme.secondaryColor};
    `;
  }
  if (variant === 'outline-primary') {
    return css`
      background-color: transparent;
      border: 1px solid ${(props) => props.theme.primaryColor};
      color: ${(props) => props.theme.primaryColor};
      font-weight: 700;
      &:hover {
        border: 1px solid ${(props) => props.theme.fontColor};
        color: ${(props) => props.theme.fontColor};
      }
    `;
  }
  if (variant === 'outline-secondary') {
    return css`
      background-color: transparent;
      border: 1px solid ${(props) => props.theme.secondaryColor};
      color: ${(props) => props.theme.secondaryColor};
      &:hover {
        border: 1px solid ${(props) => props.theme.fontColor};
        color: ${(props) => props.theme.fontColor};
      }
    `;
  }
  if (variant === 'outline-light') {
    return css`
      background-color: transparent;
      border: 1px solid white;
      color: white;
    `;
  }
  return '';
};

const defaultStyle = css`
  display: inline-block;
  padding: 15px 40px;
  border-radius: ${(props) => props.theme.borderRadius};
  font-family: ${(props) => props.theme.standoutFontFamily};
  color: white;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    opacity: .8;
  }
  svg {
    width: 23px;
  }
`;

const Button = styled.button`
  ${defaultStyle}
  ${(props) => getVariant(props.variant)};
  &:disabled, &[disabled] {
    background-color: gray;
    cursor: wait;
  }
`;

const StyledLink = styled(Link)`
  ${defaultStyle}
  ${(props) => getVariant(props.variant)};
`;

export const StyledOutboundLink = styled.a`
  ${defaultStyle}
  ${(props) => getVariant(props.variant)};
`;

export default null;
